import { each } from 'lodash-es';

export function convertDateFields(object: Object, fieldNames: string[]) {
    each(fieldNames, (field) => {
        object[field] = new Date(object[field]);
    });
}
